export const TYPES_ARCHIVES = {
  CSV: ".csv",
  XLS: ".xls",
};
